import { useMemo } from "react";

export const StarField = ({ count = 60, className = "" }) => {
    const stars = useMemo(
        () =>
            Array.from({ length: count }, (_, i) => ({
                key: i,
                left: Math.random() * 100,
                top: Math.random() * 100,
                size: Math.random() * 2 + 1,
                delay: Math.random() * 7,
                duration: 3.5 + Math.random() * 5,
            })),
        [count],
    );
    return (
        <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
            {stars.map((s) => (
                <span
                    key={s.key}
                    className="star"
                    style={{
                        left: `${s.left}%`,
                        top: `${s.top}%`,
                        width: s.size,
                        height: s.size,
                        animationDelay: `${s.delay}s`,
                        animationDuration: `${s.duration}s`,
                    }}
                />
            ))}
        </div>
    );
};
